import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

/** ========= THEME BOOTSTRAP (FORZADO) =========
 *  - SIEMPRE modo oscuro, independientemente del navegador/sistema
 *  - Deja persistido "dark" para evitar que alguna parte lo cambie
 *  - Define color-scheme para inputs/scrollbars del navegador
 */
(() => {
  try {
    const themeKey = "calins.app.theme";
    const validThemes = new Set(["classic", "violet", "copper", "midnight", "navy", "ocean", "forest", "bubblegum"]);
    const savedTheme = localStorage.getItem(themeKey);
    const theme = validThemes.has(savedTheme) ? savedTheme : "classic";

    document.documentElement.setAttribute("data-app-theme", theme);
    document.documentElement.classList.toggle("dark", true);
    document.documentElement.style.colorScheme = "dark";
    localStorage.setItem(themeKey, theme);
    localStorage.setItem("theme", "dark");
  } catch {
    // fallback: no romper el render
  }
})();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
